import heic2any from 'heic2any';

/**
 * Converts HEIC/HEIF files to JPEG format for browser compatibility
 * @param {File} file - The HEIC/HEIF file to convert
 * @returns {Promise<File>} - The converted JPEG file
 */
export const convertHeicToJpeg = async (file) => {
  try {
    // Check if the file is HEIC/HEIF
    if (!file.type.includes('heic') && !file.type.includes('heif')) {
      // Not a HEIC/HEIF file, return as is
      return file;
    }

    console.log('[HEIC Converter] Converting HEIC/HEIF file to JPEG');

    // Convert HEIC to JPEG
    const convertedBlob = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.8 // Good quality while keeping file size reasonable
    });
    // heic2any returns an array, so we take the first element
    const jpegBlob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

    // Create a new File object with JPEG MIME type
    const jpegFile = new File([jpegBlob], file.name.replace(/\.(heic|heif)$/i, '.jpg'), {
      type: 'image/jpeg',
      lastModified: file.lastModified
    });

    console.log('[HEIC Converter] Conversion successful');
    return jpegFile;
  } catch (error) {
    console.error('[HEIC Converter] Conversion failed:', error);
    // If conversion fails, return the original file
    // This will cause the upload to fail with the original error handling
    return file;
  }
};
